import { query, save, modify, remove, get } from '@/services/config/datasource';

export default {
  namespace: 'dataSource',
  state: {
    data: [],
    createModalVisible: false,
    entity: undefined,
  },

  effects: {
    *queryDataSource({ payload, callback }, { call, put }) {
      const response = yield call(query, payload);
      if (callback) callback(response);
    },
    *saveDataSource({ payload, callback }, { call, put }) {
      const response = yield call(save, payload);
      if (callback) callback(response);
    },
    *modifyDataSource({ payload, callback }, { call, put }) {
      const response = yield call(modify, payload);
      if (callback) callback(response);
    },
    *remove({ payload, callback }, { call, put }) {
      const response = yield call(remove, payload);
      if (callback) callback(response);
    },
    *getDataSource({ payload, callback }, { call, put }) {
      const response = yield call(get, payload);
      if (callback) callback(response);
    },
  },

  reducers: {
    success(state, action) {
      return {
        ...state,
        data: action.payload,
      };
    },
    saveEntity(state, action) {
      return {
        ...state,
        entity: action.payload,
      };
    },
  },
};
